<template>
  <!-- 头部组件 -->
  <div class="header">
    <div class="logo">
      <img src="../assets/images/logo01.png" alt="" />
    </div>
    <div class="nav">
      <!-- <el-menu default-active="/" class="el-menu-demo" mode="horizontal" router>
        <el-menu-item
          v-for="(item, i) in navList"
          :key="i"
          :index="item.path"
          >{{ item.name }}</el-menu-item
        >
      </el-menu> -->
      <ly-tab
        v-model="selected_Id"
        :items="items"
        :options="options"
        @change="eventHandle"
      >
      </ly-tab>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    selectedId:{
      type:Number,
      default:0
    }
  },
  data() {
    return {
      selected_Id:this.selectedId,
      items: [
        {
          path: "/",
          label: "首页",
        },
        {
          path: "/solution",
          label: "解决方案",
        },
        {
          path: "/caseAndUse",
          label: "案例及应用",
        },
        {
          path: "/newsCenter",
          label: "新闻中心",
        },
        // {
        //   path: "/contactUs",
        //   label: "联系我们",
        // },
         {
          path: "/aboutUs",
          label: "关于我们",
        },
      ],
      options: {
        activeColor: "#fff",
        // 可在这里指定labelKey为你数据里文字对应的字段
      },
    };
  },
  methods: {
    eventHandle(itemObj, i) {
      console.log(itemObj, i);
      // this.selectedId = i;
      this.$router.push({ path: itemObj.path });
    },
  },
};
</script>

<style lang="scss">
.header {
  width: 100%;
  padding: 11px 0;
  background: rgba(0,0,0,.1);
  // background: transparent;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  .logo {
    width: 200px;
    height: 100%;
    text-align: right;
    img {
      width: 201px;
      height: 78px;
    }
  }
  .nav {
    width: 20rem;
    height: 100%;
    display: flex;
    justify-content: space-around;
    margin-left: 20px;
    .ly-tab {
      width: 100%;
      height: 100%;
      // line-height: 58px;
      .ly-tabbar {
        border: none;
        box-shadow: none;
        background: transparent;
        color: #fff;
        .ly-tab-list {
          height: 78px;
        }
        .ly-tab-item {
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: 400;
        }
        .ly-tab-item:hover{
          cursor: pointer;
        }
      }
    }
    //   .el-menu {
    //     background: transparent;
    //   }
    //   .el-menu-item {
    //     padding: 0 3vw;
    //     // padding: 0 60px;
    //   }
    //   .el-menu.el-menu--horizontal {
    //     border: none;
    //     // background: transparent;
    //   }
    //   .el-menu--horizontal > .el-menu-item {
    //     height: 78px;
    //     line-height: 78px;
    //     font-size: 24px;
    //     font-family: Source Han Sans CN;
    //     font-weight: bold;
    //     color: #ffffff;
    //   }
    //   .is-active {
    //     border-bottom: 2px solid #fff;
    //   }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/header.vue